// client\src\App.jsx


import { useState } from 'react';
import styles from './App.module.css';
import api from './api/axios';
import { FaCheck, FaTimes, FaExclamation } from 'react-icons/fa';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './css/notifications.css';
import { useEffect } from 'react';
import notifications from './components/notifications';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parse, startOfWeek, getDay, parseISO, addMinutes } from 'date-fns';
import CalendarioEntrevista from './components/Graficos/CalendarioEntrevista';
import { isAuthenticated } from '../src/index';
import ChatGPT from "./components/ChatGPT";
import { SpeedInsights } from "@vercel/speed-insights/react"


function App() {
  <SpeedInsights/>
      const { userNome, userCpf, userPermission } = isAuthenticated();
  
  /* Inicializa o objeto que contem quem possui uma pendencia p resolver */
  const [pendenciaOn, setPendenciaOn] = useState([]);
  /* Inicializa variável responsável por dizer qual notificação vai aparecer. */
  const [notificationType, setNotificationType] = useState(0);
  let pickDatePlus = new Date();
  pickDatePlus.setDate(pickDatePlus.getDate() + 180);
  /* Novas variáveis de cadastro AUXILIAR */
  const [userId, setUserId] = useState(0);


  /* Variáveis para Filtro */
  const [filtroGrupo, setFiltroGrupo] = useState(-1);
  const [filtroCidade, setFiltroCidade] = useState(-1);
  const [filtroStatus, setFiltroStatus] = useState(-1);
  const [filtroVendedorProd, setFiltroVendedorProd] = useState(-1);
  const [filtroProdutor, setFiltroProdutor] = useState(-1);
  const [filtroStatusProd, setFiltroStatusProd] = useState(-1);

  const [usersList, setUsersList] = useState([]);
  const [usersListProd, setUsersListProd] = useState([]);

  const [atu, setAtu] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);



  async function updateStatus(id, statusDef) {
    console.log("update: " + id + statusDef)
    try {
      const res = await api.post('/updateStatus', {
        id: id,
        status: statusDef,
      });
      if (res.data === true) {
        getUsers();
      }
    } catch (error) {
      console.log(error)
      console.log("erro na funcao updatestatis")
    }
  }

  useEffect(() => {
    async function getUsers() {
      const res = await api.get(`/clientes?userPermission=${userPermission}&CPF=${userCpf}`);
      const resProd = await api.get('/clientesProd');
      setUsersList(res.data);
      setUsersListProd(resProd.data);
      setFilteredDataProd(resProd.data);
      const resVendedoresProdutores = await api.get('/vendedores-produtores');
      if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
        const users = resVendedoresProdutores.data.data;
        const usersFiltrado = users.filter(user => user.is_vendedor === 1)
        setVendedoresList(usersFiltrado);
        setProdutoresList(users.filter(user => user.is_produtor === 1));
        const vendedoresComPendencias = [];
        for (var i = 0; i < usersFiltrado.length; i++) {
          // const cpfUser = usersFiltrado[i].cpf;
          if (
            (res.data.filter((items) => items.vendedor == usersFiltrado[i].cpf && items.status == 1)).length !== 0
            || (res.data.filter((items) => items.vendedor == usersFiltrado[i].cpf && items.status == 3)).length !== 0
            || (res.data.filter((items) => items.vendedor == usersFiltrado[i].cpf && items.status == 5)).length !== 0
          ) {
            const cpfUser = usersFiltrado[i].cpf;
            const UserFim = usersFiltrado[i];
            vendedoresComPendencias.push(UserFim); // Adiciona o CPF do vendedor
          }
        }
        setPendenciaOn(vendedoresComPendencias);
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
      }
    }

    async function fetchAgendamentos() {
      try {
        const response = await api.get('/agendamentos');
        setAgendamentos(response.data);
      } catch (error) {
        console.error('Erro ao listar agendamentos:', error);
      }
    }
    getUsers();
    fetchAgendamentos();
    // getAgendamentosAnalise();
  }, []);



  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);


  async function getUsers() {
    const res = await api.get('/clientes');
    const resProd = await api.get('/produzir');
    const resAgendamento = await api.get('/agendamentos');
    setUsersList(res.data);
    setUsersListProd(resProd.dataProd);
    setAgendamentos(resAgendamento.data)
    console.log("agendamentos2")
    console.log(agendamentos)
  }

  /* Notificações Customizadas */
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  const [usuariosDuplicados, setUsuariosDuplicados] = useState([]);
  useEffect(() => {
    const usuariosDuplicadosProvisorio = [];
    for (var i = 0; i < usersList.length; i++) {
      for (var y = i + 1; y < usersList.length; y++) {
        if (usersList[i].login === usersList[y].login && usersList[i].id !== usersList[y].id) {
          if (!usuariosDuplicadosProvisorio.some(user => user.id === usersList[i].id)) {
            usuariosDuplicadosProvisorio.push(usersList[i]);
          }
          if (!usuariosDuplicadosProvisorio.some(user => user.id === usersList[y].id)) {
            usuariosDuplicadosProvisorio.push(usersList[y]);
          }
        }
      }
    }
    usuariosDuplicadosProvisorio.sort(function (a, b) {
      return a.login.localeCompare(b.login);
    });
    setUsuariosDuplicados(usuariosDuplicadosProvisorio);
  }, [usersList]);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataProd, setFilteredDataProd] = useState([]);
  const [quarentenaData, setQuarentenaData] = useState([0]);
  const [filteredData2, setFilteredData2] = useState([]);
  const [filterLogin, setFilterLogin] = useState('');
  /////////////////////////////////
  useEffect(() => {
    // SE A PESSOA TENTAR PROCURAR ALGUEM APARECER TODOS!
    if (filterLogin !== '') {
      setFilteredData(usersList.filter((items) => items.login.toLowerCase().includes(filterLogin.toLowerCase())));
    }
    else if (filtroCidade == -1 && filtroGrupo == -1 && filtroStatus == -1) {
      // PADRAO
      setFilteredData(usersList.filter((items) => items.status == 0));
    }
    else if (filtroCidade == -1 && filtroGrupo == -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.status == filtroStatus));
    }
    else if (filtroCidade == -1 && filtroGrupo != -1 && filtroStatus == -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo));
    }
    else if (filtroCidade != -1 && filtroGrupo == -1 && filtroStatus == -1) {
      setFilteredData(filteredData.filter((items) => items.cidade.includes(filtroCidade)))
    }
    else if (filtroCidade == -1 && filtroGrupo != -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.status == filtroStatus));
    }
    else if (filtroCidade != -1 && filtroGrupo == -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.status == filtroStatus && items.cidade.includes(filtroCidade)));
    }
    else if (filtroCidade != -1 && filtroGrupo != -1 && filtroStatus == -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.cidade.includes(filtroCidade)));
    }
    else if (filtroCidade != -1 && filtroGrupo != -1 && filtroStatus != -1) {
      setFilteredData(usersList.filter((items) => items.grupo == filtroGrupo && items.cidade.includes(filtroCidade) && items.status == filtroStatus));
    }
  }, [usersList, filterLogin, filtroCidade, filtroGrupo, filtroStatus, userId]);
  useEffect(() => {
    if (filtroVendedorProd == -1 && filtroProdutor == -1 && filtroStatusProd == -1) {
      // PADRAO
      setFilteredDataProd(usersListProd);
    }
    else if (filtroVendedorProd == -1 && filtroProdutor == -1 && filtroStatusProd != -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.statusProd == filtroStatusProd));
    }
    else if (filtroVendedorProd == -1 && filtroProdutor != -1 && filtroStatusProd == -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.produtor == filtroProdutor));
    }
    else if (filtroVendedorProd != -1 && filtroProdutor == -1 && filtroStatusProd == -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.vendedor == filtroVendedorProd))
    }
    else if (filtroVendedorProd == -1 && filtroProdutor != -1 && filtroStatusProd != -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.produtor == filtroProdutor && items.statusProd == filtroStatusProd));
    }
    else if (filtroVendedorProd != -1 && filtroProdutor == -1 && filtroStatusProd != -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.statusProd == filtroStatusProd && items.vendedorProd == filtroVendedorProd));
    }
    else if (filtroVendedorProd != -1 && filtroProdutor != -1 && filtroStatusProd == -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.produtor == filtroProdutor && items.vendedorProd == filtroVendedorProd));
    }
    else if (filtroVendedorProd != -1 && filtroProdutor != -1 && filtroStatusProd != -1) {
      setFilteredDataProd(usersListProd.filter((items) => items.produtor == filtroProdutor && items.vendedorProd == filtroVendedorProd && items.statusProd == filtroStatusProd));
    }
  }, [usersListProd, filtroVendedorProd, filtroProdutor, filtroStatusProd]);
  useEffect(() => {
    // getUsers()
    if (quarentenaData == 0) {
      setFilteredData2(usersList.filter((items) => null));
    }
    else if (quarentenaData == 10) {
      setFilteredData2(usersList.filter((items) => (items.status == 1 || items.status == 3 || items.status == 5)));
    }
    else {
      setFilteredData2(usersList.filter((items) => (items.status == 1 || items.status == 3 || items.status == 5) && items.vendedor == quarentenaData));
    }
  }, [quarentenaData, usersList, atu]);


  const meuContexto = {
    role: "system",
    content: `Aqui estão as informações do usuário antes da conversa. O nome dele usuario é: ${JSON.stringify(userNome)}`
};



  return (
    <div className={styles.app}>
      <NotificationContainer />
      <div  className={`${styles.corTitulo} ${styles.bluea}`}  >
        <p className={styles.titulo} >Pendências</p>
      </div>
      {/* INICIO QUARENTENA */}
      <div className={styles.cadastroClienteContainer}>
        <div className={styles.tituloContainer}>
        </div>
        <div className={styles.divisor}></div>
        {/* Filtro de Clientes */}
        <div className={styles.filtroDeClientesContainer}>
          <div className={styles.filterOptionsContainer}>
            <div className={styles.containerVendedor}>
              <div className={styles.inputStyleVendedor}>
                {/* <button onClick={() => setQuarentenaData(0)}>VENDEDOR RESPONSÁVEL</button> */}
                {pendenciaOn.map(user => {
                  return (
                    <div className={styles.setPendenciaDiv} >
                      {/* <a>ihul</a> */}
                      <button className={styles.setPendenciaButton} onClick={() => setQuarentenaData(user.cpf)}>{user.nome} </button>
                      <div className={styles.bolha}>
                        {
                          (usersList.filter((items) => items.vendedor == user.cpf && items.status == 1).length)
                          + (usersList.filter((items) => items.vendedor == user.cpf && items.status == 3).length)
                          + (usersList.filter((items) => items.vendedor == user.cpf && items.status == 5).length)
                        }
                      </div>
                    </div>
                  );
                })}
                <div className={styles.setPendenciaDiv} >
                  <button className={styles.setPendenciaButton} onClick={() => setQuarentenaData(10)}>ALL</button>
                  <div className={styles.bolha}>
                    {
                      (usersList.filter((items) => items.status == 1).length)
                      + (usersList.filter((items) => items.status == 3).length)
                      + (usersList.filter((items) => items.status == 5).length)
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.divisor}></div> */}
        <div className={styles.flex} >
          <div className={styles.column} >
            <div className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}>
              <p className={styles.icon2}><FaCheck /></p><p className={styles.legenda}>&nbsp;&nbsp;Finalizar cliente</p>
            </div>

          </div>
          <div className={styles.column}>
            <div className={`${styles.editIconBox} ${styles.yellow} ${styles.margin5}`}>
              <p className={styles.icon2}><FaExclamation /></p><p className={styles.legenda}>&nbsp;&nbsp;Garantia entregue</p>
            </div>
          </div>
          <div className={styles.column}>
            <div className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}>
              <p className={styles.icon2}><FaTimes /></p><p className={styles.legenda}>&nbsp;&nbsp;Retomar fila</p>
            </div>
          </div>
        </div>
        <div className={styles.usersListContainer}>
          {filteredData2.map((user, index) => {
            // Parse JSON entrevista e formata a data
            let dataHorarioEntrevista = '';
            if (user.entrevista) {
              try {
                const entrevista = JSON.parse(user.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(parseISO(entrevista.data_horario), 'dd-MM-yy');
                }
              } catch (error) {
                console.error('Erro ao parsear entrevista:', error);
              }
            }

            return (
              <div key={user.id} className={
                user.status == "1" ? styles.userContainer :
                  user.status == "3" ? styles.userContainer + ' ' + styles.backgroundSenha :
                    user.status == "5" ? styles.userContainer + ' ' + styles.backgroundSenha :
                      styles.userContainer
              }
                onClick={() => {
                  var input = document.createElement('input');
                  input.setAttribute('value', user.login);
                  // Adiciona o elemento à página
                  document.body.appendChild(input);
                  // Seleciona o conteúdo do elemento de input
                  input.select();
                  try {
                    document.execCommand('copy');
                    console.log('Termo copiado: ' + user.login);
                    // Remove o elemento de input da página
                    document.body.removeChild(input);
                    setNotificationType(19);
                  } catch (err) {
                    console.log('Unable to copy!');
                  }
                }
                } >
                <div className={styles.userContainer3}>
                  <div className={styles.editContainer}>
                    <div className={`${styles.editIconBoxes}`}>
                      <p style={{
                        padding: "5px", backgroundColor: "var(--corPrimaria)", borderRadius: "10px", color: "white", marginRight: "5vw"
                      }}>{dataHorarioEntrevista.split('T')[0]}</p>
                      <div onClick={async () => { await updateStatus(user.id, 2) }}
                        className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}>
                        <p className={styles.icon2}><FaCheck /></p>
                      </div>
                      <div onClick={async () => { await updateStatus(user.id, 4); }} className={`${styles.editIconBox} ${styles.yellow} ${styles.margin5}`}>
                        <p className={styles.icon2}><FaExclamation /></p>
                      </div>
                      <div onClick={async () => { await updateStatus(user.id, 0) }} className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}>
                        <p className={styles.icon2}><FaTimes /></p>
                      </div>
                    </div>
                    <div className={`${styles.editLogin}`}>
                      {user.vendedor !== 0 ?
                        <p className={styles.icon2}>
                          {vendedoresList.find(vendedor => vendedor.cpf === user.vendedor)?.nome || 'Vendedor não encontrado'}
                        </p>
                        :
                        <></>
                      }
                    </div>
                  </div>
                </div>
                <div >
                  <p className={`${styles.loginContainer2}`} id='copiar2'>{user.login}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div >
      {/* FIM DOS QUARENTENA */}

      {/* INICIO CALENDARIO */}
      <div style={{ marginTop: "40px" }}>
        <CalendarioEntrevista />

      </div>

      <div className={styles.sliderContainer}
                style={{
                    marginTop: "20px",
                }}
            >
                <a href={"https://chromewebstore.google.com/detail/ds-editor/hicdanpokmlhkkcpblhmjckieofeipid"} target="_blank" rel="noopener noreferrer">
                    <img
                        src={'/banner/banner1wp.webp'}
                        className={styles.sliderImage}
                    />
                </a>
            </div>


      <div className={styles.buttonBigDiv}>
        <a href='/produzir' className={`${styles.buttonBig} ${styles.green}`}>
          PRODUZIR
        </a>
        <a href='/producao' className={`${styles.buttonBig}`} style={{ backgroundColor: "black", color: "white" }}>
          PRODUÇÃO
        </a>
        <a href='/financeiro' className={`${styles.buttonBig} ${styles.yellow}`}>
          FINANÇAS
        </a>
        <a href='/monitorar' className={`${styles.buttonBig} ${styles.red}`}>
          MONITORAR
        </a>
        <a href='/adm' className={`${styles.buttonBig} ${styles.blue}`}>
          ADM
        </a>
        <a href='/parceiros' className={`${styles.buttonBig} ${styles.roxo}`}>
          PARCEIROS
        </a>

      </div>




            <div
                className={styles.cadastroItems06}
                style={{
                    // padding: "20px",
                    borderRadius: "20px",
                    backgroundColor: "white",
                    margin: "40px",
                    maxWidth: "600px",
                }}
            >
                <ChatGPT contextMessage={meuContexto} />
            </div>

            <div className={styles.sliderContainer}
                style={{
                    marginTop: "20px",
                }}
            >
                <a href={"https://gabrielsenna.com/ideias-para-melhorias/"} >
                    <img
                        src={'/banner/melhoria.webp'}
                        className={styles.sliderImage}
                    />
                </a>
            </div>

    </div>
  );
}

export default App;